import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ProfileResolve } from '@app/core/profile.resolve';
import { SharedModule } from '@app/shared';
import { CartState } from '@app/store/state/cart.state';
import { ButtonLoaderModule, NavigationBarModule } from '@infomaniak/angular-common';
import { NgxsModule } from '@ngxs/store';

import { OrderComponent } from './order.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from '@infomaniak/ngx-tooltip-directive';

export const routes = [
  {
    path: '',
    component: OrderComponent,
    resolve: {
      obj: ProfileResolve,
    },
    children: [
      {
        path: 'select',
        loadChildren: () => import('./selection/selection.module').then((m) => m.SelectionModule),
      },
      {
        path: 'recommendation',
        loadChildren: () => import('./recommendation/recommendation.module').then((m) => m.RecommendationModule),
      },
      {
        path: 'login',
        loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
      },
      {
        path: 'change_account',
        loadChildren: () => import('../change-account/change-account.module').then((m) => m.ChangeAccountModule),
      },
      {
        path: 'signup',
        loadChildren: () => import('../signup/signup.module').then((m) => m.SignupModule),
      },
      {
        path: 'fill_address',
        loadChildren: () => import('./address/address.module').then((m) => m.AddressModule),
      },
      {
        path: 'payment',
        loadChildren: () => import('./payment/payment.module').then((m) => m.PaymentModule),
      },
      {
        path: 'domain_contact',
        loadChildren: () => import('./domain-contact/domain-contact.module').then((m) => m.DomainContactModule),
      },
      {
        path: 'renewal_warranty',
        loadChildren: () => import('./renewal-warranty/renewal-warranty.module').then((m) => m.RenewalWarrantyModule),
      },
      {
        path: 'vps_location',
        loadChildren: () => import('./vps-location/vps-location.module').then((m) => m.VpsLocationModule),
      },
    ],
  },
];

@NgModule({
  declarations: [OrderComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    NgxsModule.forFeature([CartState]),
    NavigationBarModule,
    SharedModule,
    MatButtonModule,
    MatTooltipModule,
    MatInputModule,
    ButtonLoaderModule,
    MatSlideToggleModule,
    FormsModule,
    TooltipModule,
  ],
  exports: [OrderComponent],
})
export class OrderModule {}
